<!--
     Copyright (c) 2024 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->

<clr-input-container>
    <input clrInput
           #input
           type="text"
           name="search"
           [(ngModel)]="value"
           autocomplete="off"
           [attr.aria-label]="'Filter items'"
           [placeholder]="'Filter items'"
           [pattern]="pattern"
           (keyup.enter)="onButtonClick()">
    <clr-control-error>{{ "string.filter.bad.format" | vtranslate }}</clr-control-error>
</clr-input-container>

<button type="button"
        class="btn btn-sm btn-outline"
        (click)="onButtonClick()"
        [disabled]="!valid">
    {{ "filter.apply.button.text" | vtranslate }}
</button>

<button type="button"
        class="btn btn-sm btn-outline"
        (click)="onClearClick()"
        [disabled]="!value || value?.length === 0">
    {{ "filter.clear.button.text" | vtranslate }}
</button>


